/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type QuickViewCategoryParagraph_itemSearch = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly pageType: string | null;
    readonly " $fragmentRefs": FragmentRefs<"usePeriodGroupValue_itemSearch">;
    readonly " $refType": "QuickViewCategoryParagraph_itemSearch";
};
export type QuickViewCategoryParagraph_itemSearch$data = QuickViewCategoryParagraph_itemSearch;
export type QuickViewCategoryParagraph_itemSearch$key = {
    readonly " $data"?: QuickViewCategoryParagraph_itemSearch$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCategoryParagraph_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewCategoryParagraph_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePeriodGroupValue_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'e81bf58b95e5061b82b5a33f195f6841';
export default node;
